'use client';

import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WORDS = [
  'O',
  'Orb',
  'Orbit',
  'Orbital',
  'ONE',
  'Open',
  'Omni',
  'Origin',
  'Opportunity',
  'Overflow',
  'Overcome',
  'Odyssey',
  'Он',
  'Observe',
  'Offer',
  'Organize',
  'Optimal',
  'Original',
];

export default function RotatingO() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % WORDS.length);
    }, 1800);

    return () => clearInterval(id);
  }, []);

  return (
    <span data-component-id="src/app/landing-page/components/RotatingO.tsx:39:4" data-component-path="src/app/landing-page/components/RotatingO.tsx" data-component-line="39" data-component-end-line="53" data-component-file="RotatingO.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22relative%20inline-block%20ml-2%20w-%5B220px%5D%20h-%5B1em%5D%20align-baseline%22%7D" className="relative inline-block ml-2 w-[220px] h-[1em] align-baseline">
      <AnimatePresence data-component-id="src/app/landing-page/components/RotatingO.tsx:40:6" data-component-path="src/app/landing-page/components/RotatingO.tsx" data-component-line="40" data-component-end-line="52" data-component-file="RotatingO.tsx" data-component-name="AnimatePresence" data-component-content="%7B%22elementName%22%3A%22AnimatePresence%22%7D" mode="wait">
        <motion.span data-component-id="src/app/landing-page/components/RotatingO.tsx:41:8" data-component-path="src/app/landing-page/components/RotatingO.tsx" data-component-line="41" data-component-end-line="51" data-component-file="RotatingO.tsx" data-component-name="motion.span" data-component-content="%7B%22elementName%22%3A%22motion.span%22%2C%22className%22%3A%22absolute%20left-0%20top-0%20text-yellow-400%20font-bold%22%7D"
          key={WORDS[index]}
          initial={{ opacity: 0, rotateX: 90 }}
          animate={{ opacity: 1, rotateX: 0 }}
          exit={{ opacity: 0, rotateX: -90 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="absolute left-0 top-0 text-yellow-400 font-bold"
          style={{ transformOrigin: '50% 50%' }}
        >
          {WORDS[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
